export default {
    certificates: [],
    domain_id: 0,
    SSL_CERTIFICATE_TYPE_CUSTOM: 146001,
    SSL_CERTIFICATE_TYPE_SELF: 146002,
    SSL_CERTIFICATE_TYPE_LETSENCRYPT: 146003,
    ssl_type: {
        146001: 'CSR Generated',
        146002: 'Self Signed',
        146003: 'Let\'s encrypt'
    }
};